<div class="container gap" style="max-width: 1000px">
  <div class="one" [innerHTML]="content"></div>
  <div class="two">
    <img [attr.src]="imageSource" width="500" height="auto" alt="news" />
  </div>
</div>

<div style="clear: both">
  <mat-checkbox (change)="toggleRead()" data-cy="chk-box">Don't show me this message again.</mat-checkbox>
</div>
